import { Component, OnInit } from '@angular/core';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';
declare const dataLayer: any[];

@Component({
  selector: 'download-app',
  standalone: false,
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss'],
})
export class DownloadAppComponent implements OnInit {
  constructor(
    public busnThirdPartyService: BUSNThirdPartyService, 
    public sharedConfig: SharedConfig
  ) {}

  ngOnInit(): void {
    console.log(this.sharedConfig.appSettings.download_qr_code_image_url);
    
    dataLayer.push({
      event: 'page_show',
      screenPath: 'download-app',
      screenName: 'download-app',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  download() {
    // Option 1: Open in new tab (recommended)
    window.open(this.sharedConfig.appSettings.app_download_url, '_blank');

    // Option 2: Open in same window
    // window.location.href = this.sharedConfig.appSettings.app_download_url;

    // Option 3: Open in new tab with security features
    // const newWindow = window.open(this.sharedConfig.appSettings.app_download_url, '_blank');
    // if (newWindow) {
    //   newWindow.opener = null;
    //   newWindow.rel = 'noopener noreferrer';
    // }
  }
}